module.exports = " <div class=cardTitle _v-eed95d1c=\"\"> <slot _v-eed95d1c=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-eed95d1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardTitle.vue
// module id = 332
// module chunks = 2